import React, { useState } from 'react';
import { Box } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import HowItWorksModal from '../HowItWorksModal';

// Height the bar occupies, so a page can reserve room and never park content under it.
export const MOBILE_ACTION_BAR_PAD = 92;

/**
 * The phone thumb-zone action bar (design: CardStoreApp.dc.html vRevised, the fixed bar over the
 * route body when `showBar`).
 *
 * On a phone the revised header carries the lockup and the cart and nothing else — the primary
 * action moves down here, where a thumb actually reaches, and stays reachable however far the
 * shopper has scrolled through the rails. Desktop keeps the action in the header pill and this
 * renders nothing.
 *
 * The gradient wash is pointer-events:none so it never eats a tap meant for a card underneath;
 * only the button itself is interactive.
 */
const StoreMobileActionBar = () => {
  const [howOpen, setHowOpen] = useState(false);

  return (
    <>
      <Box
        data-testid="mobile-action-bar"
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 900,
          p: '12px 14px 16px',
          background: 'linear-gradient(to top, #FEFDF6 64%, rgba(254,253,246,0))',
          pointerEvents: 'none',
        }}
      >
        <Box
          component="button"
          type="button"
          onClick={() => setHowOpen(true)}
          sx={{
            width: '100%',
            minHeight: 54,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.125,
            pointerEvents: 'auto',
            font: 'inherit',
            fontSize: '1rem',
            fontWeight: 600,
            color: '#fff',
            backgroundColor: '#206884',
            border: 0,
            borderRadius: '27px',
            cursor: 'pointer',
            boxShadow: '0 6px 18px rgba(20,28,36,0.24)',
            '&:hover': { backgroundColor: '#185166' },
          }}
        >
          <AutoAwesomeIcon aria-hidden sx={{ fontSize: 21 }} />
          Design your own card
        </Box>
      </Box>
      <HowItWorksModal open={howOpen} onClose={() => setHowOpen(false)} />
    </>
  );
};

export default StoreMobileActionBar;
